import React, { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { classNames } from '../tools/helpers';
import { getSite } from '../tools/fetcher';

export default function Hero({ className }) {
    const { data } = useQuery({
        queryKey: ['sites'],
        queryFn: getSite,
    });

    const splitTitle = useMemo(
        () => data?.hero?.title?.split('|') || [],
        [data],
    );

    return (
        <div className={classNames('flex gap-[64px] items-center', className)}>
            <div className={'264px sm:max-w-[516px] space-y-2 sm:space-y-4'}>
                <p
                    className={
                        'font-bold text-[32px] leading-[36px] sm:text-[64px] sm:leading-[68px]'
                    }
                >
                    {splitTitle.length >= 1 && splitTitle[0]}{' '}
                    {splitTitle.length >= 2 && (
                        <>
                            <span className={'text-apart-green-50'}>
                                {splitTitle[1]}
                            </span>{' '}
                        </>
                    )}
                    {splitTitle.length >= 3 && splitTitle[2]}
                </p>
                <p className={'text-apart-black-50 leading-7 max-w-[456px]'}>
                    {data?.hero?.description}
                </p>
            </div>
            {data?.hero?.image_src && (
                <div className={'hidden sm:block'}>
                    <img
                        src={data?.hero?.image_src}
                        alt={data?.hero?.image_alt || 'Apartment'}
                    />
                </div>
            )}
        </div>
    );
}
